import { Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Header from '../modules/employee/components/Header';
import Footer from '../modules/employee/components/Footer';

const EmployeeLayout = () => {
  const { user } = useAuth();
  return (
    <div className="app">
      <Header user={user} />
      <div className="container">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default EmployeeLayout;
